export class StringUtil {

    /**
     * Remove accents from characters (NFD)
     * Lower case
     * @param str 
     * @returns 
     */
    static normalizeStringLowerCase(str: string): string {
        // remove accents
        const normalizedString: string = str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        return normalizedString
    }

    static formatString = function (format: string, ...args: any[]) {
        return format.replace(/%(\d+)%/g, function (match, number) {
            return typeof args[number] !== "undefined"
                ? String(args[number])
                : match
                ;
        });
    };

    /**
     * Splits a string by a given delimiter and optionally trims each element.
     * Returns an empty array if the input is empty or only whitespace.
     *
     * @param input - The input string to split.
     * @param delimiter - The delimiter to split by.
     * @param trim - Whether to trim each resulting element (default is true).
     * @returns An array of split (and optionally trimmed) strings.
     */
    static normalizedSplit(
        input: string,
        delimiter: string,
        trim = true
    ): string[] {
        if (input.trim() === "") return [];
        return input
            .split(delimiter)
            .map(part => (trim ? part.trim() : part));
    }
}